import { Pipe, PipeTransform } from '@angular/core';
import { UtilityService } from '@irb/irb-common/services/utility.service';

@Pipe({ name: 'easternTime', standalone: false })
export class EasternTimePipe implements PipeTransform {
  constructor(private util: UtilityService) { }
  transform(value: any) {
    return this.util.getEasternTime(value);
  }
}
